import { Link } from "react-router-dom";
import { Star, ArrowUpRight } from "lucide-react";

export const PostCard = ({ post, index = 0 }) => {
  return (
    <Link
      to={`/post/${post.slug}`}
      data-testid={`post-card-${post.slug}`}
      className="group block bg-[#FFFFFF] border border-[#E5E2D9] overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
      style={{ animationDelay: `${index * 80}ms` }}
    >
      <div className="aspect-[4/3] overflow-hidden bg-[#EFEBE1]">
        {post.cover_image ? (
          <img
            src={post.cover_image}
            alt={post.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : null}
      </div>
      <div className="p-6">
        <div className="flex items-center justify-between mb-3">
          <span className="label-caps text-[0.65rem] text-[#7A1C28]">
            {post.category || (post.type === "review" ? "Review" : "Article")}
          </span>
          {post.type === "review" && post.rating != null && (
            <span className="flex items-center gap-1 text-[#D4AF37] text-sm">
              <Star size={14} fill="#D4AF37" strokeWidth={0} />
              {post.rating}
            </span>
          )}
        </div>
        <h3 className="font-serif-display text-2xl leading-tight mb-2 group-hover:text-[#7A1C28] transition-colors">
          {post.title}
        </h3>
        {post.type === "review" && post.venue && (
          <p className="text-xs text-[#737373] mb-2">
            {post.production} · {post.venue}
          </p>
        )}
        <p className="text-sm text-[#4A4A4A] leading-relaxed line-clamp-3">{post.excerpt}</p>
        <span className="inline-flex items-center gap-1 mt-4 label-caps text-[0.65rem] text-[#1A1A1A] group-hover:text-[#7A1C28] transition-colors">
          Read more <ArrowUpRight size={14} />
        </span>
      </div>
    </Link>
  );
};
